import React, { useState } from "react";
import "./Schemes.css";

const schemeData = [
  {
    title: "Pradhan Mantri Fasal Bima Yojana (PMFBY)",
    desc: "Crop insurance for farmers against natural calamities, pests, and diseases.",
    img: "/images/schemes/sch1.jpg",
    link: "https://pmfby.gov.in",
  },
  {
    title: "MGNREGA",
    desc: "Guarantees 100 days of wage employment every year to rural households.",
    img: "/images/schemes/sch2.jpg",
    link: "https://nrega.nic.in",
  },
  {
    title: "Swachh Bharat Mission (Gramin)",
    desc: "Promotes cleanliness and sanitation in rural areas.",
    img: "/images/schemes/sch3.jpg",
    link: "https://swachhbharatmission.gov.in",
  },
  {
    title: "Atal Pension Yojana",
    desc: "Monthly pension benefits for unorganized sector workers.",
    img: "/images/schemes/sch4.jpg",
    link: "https://npscra.nsdl.co.in/scheme-details.php",
  },
  {
    title: "Ujjwala Yojana",
    desc: "Free LPG connections for women in BPL households.",
    img: "/images/schemes/sch5.jpg",
    link: "https://pmuy.gov.in",
  },
  {
    title: "Stand-Up India Scheme",
    desc: "Loans for SC/ST and women entrepreneurs.",
    img: "/images/schemes/sch6.jpg",
    link: "https://www.standupmitra.in",
  },
  {
    title: "Digital India",
    desc: "Aims to digitally empower rural citizens.",
    img: "/images/schemes/sch7.jpg",
    link: "https://www.digitalindia.gov.in",
  },
  {
    title: "Jan Dhan Yojana",
    desc: "Free and zero-balance bank accounts for citizens.",
    img: "/images/schemes/sch8.jpg",
    link: "https://pmjdy.gov.in",
  },
  {
    title: "Kisan Credit Card (KCC)",
    desc: "Affordable credit facility for farmers.",
    img: "/images/schemes/sch9.jpg",
    link: "https://pmkisan.gov.in",
  },
  {
    title: "Pradhan Mantri Krishi Sinchai Yojana (PMKSY)",
    desc: "Encourages efficient water usage in farming.",
    img: "/images/schemes/sch10.jpg",
    link: "https://pmksy.gov.in",
  },
  {
    title: "Soil Health Card Scheme",
    desc: "Soil testing & fertility reports for farmers.",
    img: "/images/schemes/sch11.jpg",
    link: "https://soilhealth.dac.gov.in",
  },
  {
    title: "Paramparagat Krishi Vikas Yojana (PKVY)",
    desc: "Promotes organic farming practices.",
    img: "/images/schemes/sch12.jpg",
    link: "https://pgsindia-ncof.gov.in",
  },
  {
    title: "e-NAM",
    desc: "Online platform for farmers to sell crops.",
    img: "/images/schemes/sch13.jpg",
    link: "https://enam.gov.in",
  },
  {
    title: "Rashtriya Krishi Vikas Yojana (RKVY)",
    desc: "State support for agricultural development.",
    img: "/images/schemes/sch14.jpg",
    link: "https://rkvy.nic.in",
  },
];

export default function Schemes() {
  const [search, setSearch] = useState("");

  const filtered = schemeData.filter(
    (s) =>
      s.title.toLowerCase().includes(search.toLowerCase()) ||
      s.desc.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="schemes-page-container">
      <h2 className="schemes-title">Government Schemes & Yojanas</h2>

      <input
        type="text"
        className="schemes-search"
        placeholder="Search for a scheme..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {filtered.length === 0 ? (
        <p className="schemes-no-result">No schemes found!</p>
      ) : (
        <div className="schemes-list">
          {filtered.map((item, index) => (
            <div className="schemes-card" key={index}>
              <img src={item.img} alt={item.title} />
              <div className="schemes-info">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <a href={item.link} target="_blank" rel="noreferrer">
                  Learn more →
                </a>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        className="schemes-top-btn"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        ⬆
      </button>
    </div>
  );
}
